
import { defineComponent, ref, toRefs, computed, watch } from "vue";
import DateTimeProps from "./props";

export default defineComponent({
  name: "dateTime",
  props: { ...DateTimeProps },
  setup(props, { emit }) {
    const date = ref("");
    const time = ref<string[] | null>(null);
    const { modelValue, defaultValue } = toRefs(props);
    const value = computed<string | undefined>({
      get() {
        let res;
        if (date.value && time.value) {
          res = date.value + " " + (time.value as string[]).join(":");
        }
        return res;
      },
      set(val) {
        if (val) {
          let arr = val.split(" ");
          date.value = String(arr[0]);
          time.value = (arr[1] as string).split(":");
        } else {
          date.value = "";
          time.value = null;
        }
      },
    });
    const setValue = () => {
      value.value = modelValue.value as string;
    };
    const dispatch = () => {
      emit("update:modelValue", value.value);
    };
    if (modelValue.value) {
      setValue();
    } else {
      if (defaultValue.value === 0) {
        emit("update:modelValue", new Date().pattern("yyyy-MM-dd HH:mm"));
      } else if (defaultValue.value) {
        emit("update:modelValue", defaultValue.value);
      }
    }
    watch(modelValue, setValue);
    watch(value, dispatch);
    return {
      date,
      time,
    };
  },
});
